module.exports = "/static/assets/4ba4257bf61c1879dd8136e4cc7787dd.png";